import React from 'react'
import ReactDOM from 'react-dom'
import {Chart, registerables} from 'chart.js'

// Apps
import {App} from './app/App'
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/style.react.scss'
import './_metronic/assets/css/App.css'


import { MetronicI18nProvider } from './_metronic/i18n/Metronici18n'
// const {PUBLIC_URL} = process.env
//  console.log('public _URL --- ', PUBLIC_URL)


Chart.register(...registerables)

// export function extractAPIErrorResponse(axios: AxiosInstance) {
  // axios.interceptors.response.use(undefined, function (error: AxiosError) {
  //     (error as any).originalMessage = error.message;
  //     Object.defineProperty(error, "message", { get: function () {
  //         if (!error.response) {
  //             return (error as any).originalMessage;
  //         }
  //         return JSON.stringify(error.response.data);
  //     }});
  //     return Promise.reject(error);
  // })
// }

ReactDOM.render(
  
  <MetronicI18nProvider>
    <App basename={''} />
  </MetronicI18nProvider>
  ,
  document.getElementById('root')
)







